import type { CreateDailyFeedMixDto, OptimizedFeedMix } from '../../api/nutrition';

export interface OptimizerFormSnapshot {
  targetDate: string;
  targetQuantity: number;
  location?: string;
  operator?: string;
  optimizationGoal?: string;
}

export function buildCreateMixFromOptimization(
  result: OptimizedFeedMix,
  form: OptimizerFormSnapshot,
  options?: {
    location?: string;
    operator?: string;
    birdCount?: number;
    notes?: string;
  },
): CreateDailyFeedMixDto {
  const location = options?.location ?? form.location;
  return {
    feedDate: form.targetDate,
    location: location || undefined,
    operator: options?.operator ?? form.operator,
    birdCount: options?.birdCount,
    notes:
      options?.notes ??
      `Optimized mix (score ${result.optimization.score}/100, goal: ${result.optimization.goal})`,
    feedComponents: result.optimizedMix.map((component) => ({
      feedStockId: component.feedStockId,
      quantity: component.quantity,
      notes: `${component.percentage.toFixed(1)}% of mix`,
    })),
    tags: ['optimizer', 'dispense-ready'],
    specialNotes: result.optimization.improvements.join('; '),
  };
}
